<template>
  <div id="app">
    <div class="menu-box" v-if="screenWidth > 750">
      <div class="log-box">
        <img src="@/assets/logo.png" alt="">
        <span>WING OF INTEGRITY LENDING</span>
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'choice' : ''">Home</div>
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">Our advantage</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">Features of Internet Finance</div>
        <div @click="choiceMenu(3)" :class="(menuIndex === 3) ? 'choice' : ''">Partner evaluation</div>
      </div>
    </div>
    <div id='home' ref="home"></div>
    <div class="banner-box">
      <div class="left-box">
        <div>Easy loans to support your future</div>
      </div>
      <img src="../assets/img_1.png" class="img_1">
    </div>
    <div id='step_1' ref="step_1"></div>
    <div class="actually-care-box">
      <div class="title">Our advantage</div>
      <div class="actually-text">
        <!-- <div>As an online compliance financial application in the Philippines, WING OF INTEGRITY LENDING takes security, compliance, simplicity and transparency as its core values to meet users' main concerns about borrowing applications. </div> -->
        <p>Wing of Integrity Lending Corp., an Internet finance company located in the Philippines, its main advantage is in providing diversified loan services, such as small loans and car loans. Through its strong R&D and IT departments, the company provides users with a simple, fast and secure online loan platform, making the loan process more efficient and convenient. In addition, the company not only focuses on the innovation and optimization of financial services, but also actively participates in public welfare and social public undertakings, demonstrating its commitment to social responsibility. These factors together constitute Wing of Integrity Lending Corp.'s competitive advantage in the market, attracting a wide range of customer groups, and also earning the company a good social reputation.</p>

      </div>
      <img src="../assets/img_2.png" class="img_2">
    </div>

    <div class="help-box">
      <div class="info-box-text">
        <img src="../assets/logo-1.png" class="img_2_logo">
        EasyBorrow
      </div>
      <div class="help-text-box">
        <p>Our APP</p>
        <div> Easy Borrow is a professional online financial loan APP developed by SEC-registered company WING OF INTEGRITY LENDING and regulated by the Securities and Exchange Commission of the Philippines (SEC).
          <br> Easy Borrow provides convenient online loan application services with simple processes and fast review, bringing efficient financial solutions to users. Easy Borrow looks forward to providing you with high-quality financial services.
        </div>
      </div>

    </div>

    <div id='step_2' ref="step_2"></div>
    <div class="list-box">
      <div class="title">Features of Internet Finance</div>
      <div class="list-item-box">
        <div class="item">
          <div class="img-box">
            <img src="../assets/icon-1.png" alt="">
          </div>
          <div class="sbtitle">Efficient and convenient</div>
          <div class="item-text"> Internet finance provides fast and simple services, greatly shortening transaction time and processes.</div>
        </div>
        <div class="item">
          <div class="img-box">
            <img src="../assets/icon-2.png" alt="">
          </div>
          <div class="sbtitle">No geographical restrictions</div>
          <div class="item-text"> Regardless of location, as long as there is an Internet connection, financial transactions and services can be performed.</div>
        </div>
        <div class="item">
          <div class="img-box">
            <img src="../assets/icon-3.png" alt="">
          </div>
          <div class="sbtitle">Personalized service</div>
          <div class="item-text">Provide customized financial products and services based on user needs and data.</div>
        </div>
        <div class="item">
          <div class="img-box">
            <img src="../assets/icon-4.png" alt="">
          </div>
          <div class="sbtitle">Technological innovation drive</div>
          <div class="item-text">Use the latest technologies, such as big data and artificial intelligence, to improve the efficiency and security of financial services.</div>
        </div>
      </div>
    </div>
    <div id='step_3' ref="step_3"></div>
    <div class="help-box">
      <div class="help-text-box">
        <p>Partner evaluation</p>
        <div>
          As an investor working with Wing of Integrity Lending Corp., I am very pleased with this partnership. The company has demonstrated excellent market insights and strong technological innovation capabilities. Their professional knowledge in the field of Internet finance and keen insight into market needs have enabled our cooperation projects to achieve remarkable results. In particular, their online loan platform not only provides users with efficient and convenient services, but also ensures the security and transparency of transactions. In addition, we were deeply impressed by the Wing of Integrity team’s professionalism and commitment to social responsibility. They not only focus on business development, but also actively participate in public welfare undertakings. This comprehensive strength and sense of social responsibility make us confident in future cooperation. All in all, Wing of Integrity is a trustworthy partner and we look forward to more in-depth cooperation in the future.
        </div>
      </div>
      <img src="../assets/img_3.png" class="img_3">
    </div>
    <!-- <div id='step_4' ref="step_4"></div>
    <div class="partner-box">
      <div class="title">Our business partner</div>
      <div class="img-box">
        <img src="../assets/list-1.png" alt="">
        <img src="../assets/list-2.png" alt="">
        <img src="../assets/list-3.png" alt="">
        <img src="../assets/list-4.png" alt="">
        <img src="../assets/list-5.png" alt="">
      </div>
    </div> -->
    <div id='step_5' ref="step_5"></div>
    <div class="foot-box">
      <div class="foot-text">
        <div>Quick Links</div>
        <p>Home</p>
      </div>
      <div class="foot-text">
        <div>We Provide</div>
        <p>Paid Media</p>
        <p>Content & Social Media Marketing</p>
        <p>Search Engine Optimization (SEO)</p>
        <p>Influencer Marketing</p>
      </div>
      <div class="foot-text">
        <div>Get In Touch</div>
        <p>
          <img src="../assets/tel.png" alt="">
          Our working hours are Monday through Saturday, 9:00 am to 6:00 pm.
        </p>
        <p>
          <img src="../assets/mail.png" alt="">
          wingofintegrity@hotmail.com
        </p>
        <p>
          <img src="../assets/address.png" alt="">
          U.A. 8TH FLOOR, THE W FIFTH TOWER AVE.BLDG. 5TH AVE. ST. TAGUIG CITY
        </p>
      </div>
    </div>
    <div class="copyright">Copyright © 2023.WING OF INTEGRITY LENDING.</div>
  </div>
</template>

<script>
import privacy from "@/components/privacy";

import 'swiper/css/swiper.min.css'
export default {
  name: 'App',
  components: {
    privacy,
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      content: '1',
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    let item = this.$route.query.item
    console.log(item);
    if (item == 'partners') {
      this.$nextTick(() => {
        setTimeout(() => {
          this.choiceMenu(6)
        }, 1000);
      })
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("home").scrollIntoView(); break;
        case 1: document.getElementById("step_1").scrollIntoView(); break;
        case 2: document.getElementById("step_2").scrollIntoView(); break;
        case 3: document.getElementById("step_3").scrollIntoView(); break;
        case 4: document.getElementById("step_4").scrollIntoView(); break;
        case 5: document.getElementById("step_5").scrollIntoView(); break;
        case 6: document.getElementById("step_6").scrollIntoView(); break;
        case 7: document.getElementById("step_7").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    }
  }
}
</script>


<style lang="less">
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
